module.exports = __webpack_public_path__ + "4cc9f2e621975daba279c47f06c476b2.MP3";